import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import AssignmentIcon from "@material-ui/icons/Assignment";
import LaptopChromebookIcon from "@material-ui/icons/LaptopChromebook";
import SearchIcon from "@material-ui/icons/Search";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import FindInPageIcon from "@material-ui/icons/FindInPage";

import { isAppraisalCase } from "components/Shared/Functions";

const fieldIcons = {
  1: <AssignmentIcon />,
  2: <AssignmentIndIcon />,
  3: <SearchIcon />,
  4: <AssignmentTurnedInIcon />,
};
const appraisalIcons = {
  1: <AssignmentIcon />,
  2: <AssignmentIndIcon />,
  3: <EventAvailableIcon />,
  4: <SearchIcon />,
  5: <LaptopChromebookIcon />,
  6: <FindInPageIcon />,
  7: <AssignmentTurnedInIcon />,
};

function StatusTrackerIcon(props) {
  const { active, completed, caseHeader } = props;

  const icons = caseHeader && isAppraisalCase(caseHeader)
    ? appraisalIcons : fieldIcons;

  const customClass =
    `stepper-icon ${completed ? "completed" : ""} ${active ? "active" : ""} ${!(completed || active) ? "pending" : ""}`;

  return (
    <div className={customClass}>
      {icons[String(props.icon)]}
    </div>
  );
}

StatusTrackerIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
  icon: PropTypes.node,
  caseHeader: PropTypes.object,
};

const mstp = state => {
  return {
    caseHeader: state.caseForms.caseHeader,
  };
};

export default connect(mstp)(StatusTrackerIcon);